import React, { useEffect, useState } from "react";
import { copyBlockDates, getMediumSchedulesList } from "../../../../services/medium";
import { items } from "../data";
import { el } from "date-fns/locale";
import { toast } from "react-toastify";

export default function CopyModalNew({ is_group_session, setOpenCopy2, activemedium_availability_id, callBackSchedules, medium_id }) {

    const [countryType, setCountryType] = useState(""); // default selected option
    const [showTable, setShowTable] = useState(true);
    const [checkboxItems, setcheckboxItems] = useState([]);

    const [selectedItems, setSelectedItems] = useState([]);

    const handleChange1 = (e) => {
        const value = parseInt(e.target.value); // convert to number if schedule_id is number
        const checked = e.target.checked;

        setSelectedItems((prev) =>
            checked ? [...prev, value] : prev.filter((id) => id !== value)
        );
    };


    useEffect(() => {
        getSchedules()
    }, [])

    const getSchedules = () => {
        let body = {
            // get_group_schedules: is_group_session === 0 ? 'no' : 'yes',
            from_schedule_id: activemedium_availability_id,
            medium_id: Number(medium_id),
        };
        getMediumSchedulesList(body)
            .then((data) => {
                if (data.data.status) {
                    console.log(data.data.data);
                    setcheckboxItems(data.data.data)
                }
            })
            .catch(() => { });
    };
    const SubmitHandler = () => {
         if (selectedItems.length === 0) {
            return;
        }

        let body = {
            from_schedule_id: activemedium_availability_id,
            to_schedule_id: selectedItems.join(',')
        }

        copyBlockDates(body).then((data) => {
            if (data.data.status) {
                toast.success(data.data.message, { position: "top-center" });
                callBackSchedules();
                window.loadModal2("#CopyModalNew", "hide");
                window.removeBackdrop()
                setTimeout(() => {
                    setOpenCopy2(false);
                }, 200);
            }
            else {
                toast.error(data.data.message, { position: "top-center" });
            }
        }).catch(() => {
            toast.error("Something went wrong", { position: "top-center" });
        })
    }
    return (
        <div>
            <div
                id="CopyModalNew"
                className="modal fade bd-example-modal-lg mt-5 preview-modal-availability overflow-scroll "
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-preview">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Copy Blocked Dates
                            </h5>
                        </div>

                        <div className="meeting-preferences-box-row mb-2 mt-5 clear-both">

                            <h4 className="text-center">
                                What Schedule would you like to copy to?
                            </h4>

                        </div>
                        {showTable && (
                            <div className="availability-window-table availability-window-table-1">
                                <table>
                                    {checkboxItems.length > 0 ? (
                                        checkboxItems.map((item) => (
                                            <tr>
                                                <td>
                                                    <div class="form-group">
                                                        <input
                                                            type="checkbox"
                                                            value={item.schedule_id}
                                                            checked={selectedItems.includes(item.schedule_id)}
                                                            onChange={handleChange1}
                                                            className="mr-2"
                                                            name={item.session_name}
                                                            id={item.session_name}
                                                        />
                                                        <label htmlFor={item.session_name}>{item.session_name}</label>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                    <tr>
                                        <td>
                                        <span style={{ textAlign: "center",width: "unset",paddingBottom : "19px" }}>
                                           No Sessions Available to Copy. Please select a different option.
                                        </span>
                                        </td>
                                    </tr>
                                    )}
                                </table>
                            </div>
                        )}
                        <div className="d-flex align-items-center justify-content-center mb-5">



                            <>
                                <button
                                    onClick={() => setOpenCopy2(false)}
                                    data-dismiss="modal"
                                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={SubmitHandler}
                                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                                >
                                    Submit
                                </button>
                            </>

                        </div>
                        {/* Debug: You can remove this */}
                        {/* <div className="p-3">
              <strong>Selected:</strong> {selectedCountries.join(", ")}
            </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
